import styled, { keyframes, css } from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  height: auto;
  
  gap: 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;

  >div:first-child{
    height: 50px;

    margin-bottom: 0;
  }

   @media (max-width: 880px) {
    margin-top: 2rem;
  } 

  @media (max-width: 760px) {
    margin: 0;
    padding: 0;
  } 
`;

const loadingAnimation = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 0.8; }
  100% { opacity: 0.5; }
`;

export const List = styled.div`
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ loading }) =>
    loading &&
    css`
      animation: ${loadingAnimation} 0.7s infinite ease;
    `}
`

export const Item = styled.div`
  width: 100%;
  padding: 0.75rem;
  
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
  border-radius: 0.5rem;
  border: 2px solid #F3F3F5;
  position: relative;

  .div-primary {
    gap: 0.5rem;
    display: flex;
    flex-direction: column;

    .div-primary-one {
      gap: 0.5rem;
      display: flex;

      p:nth-of-type(2) {
        &::before {
          content: "•";
          color: #CED2DC;
          margin-right: 0.5rem;
        }
      }
    }
    
    .div-primary-two {
      display: flex;
      align-items: center;

      p:nth-of-type(2){
        &::before {
          content: "•";
          color: #8A92A2;
          margin-inline: 0.5rem;
        }
      }
    }
  }

  .div-secondary {
    width: auto;
    height: auto;
    
    gap: 0.8rem;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    position: relative;

    .types {
      gap: 0.5rem;
      display: flex;
      flex-wrap: wrap;
      
    }

    .cta-hover {
      position: absolute;
      right: 0;
      top: 0;

      width: 100%;
      min-width: 320px;
      height: 100%;

      gap: 8px;
      display: flex;
      align-items: center;

      background-color: #FFFFFF;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s ease;
      justify-content: flex-end;

      .btnv2 {
        max-width: 162px;
        width: 100%;
        height: 40px;
        gap: 8px;
        padding: 0.75rem 1rem;
      }

      .btnv2 img {
        width: 16px;
        height: 16px;
        filter: brightness(0) invert(1);
      }

      @media (max-width: 479px) {
        min-width: auto;
        flex-direction: column;

      }
    }
  }

  
  &:hover .div-secondary .cta-hover {
    opacity: 1;
    pointer-events: auto;
  }


  @media (max-width: 1110px) {
    gap: 2rem;  
    flex-direction: column;

      .div-secondary {
        align-items: flex-start;
      }
    }
`

export const Type = styled.div`
  padding: 0.3125rem 0.5rem;
  
  gap: 0.25rem;
  display: flex;
  
  align-items: center;
  border-radius: 999px;
  background-color: ${({ bgGreen }) => (bgGreen ? `${theme.colors.green.Verde_AgroReceita}` : "#E9ECF0")};

  >img {
    width: 16px;
    height: auto;
  }
`;

export const ContainerModalRight = styled.div`
  width: 100%;
  height: auto;
  
  gap: 1rem;
  display: flex;
  align-self: start;
  flex-direction: column;
`;

export const ContainerInfo = styled.div`
  width: auto;
  height: auto;
  
  /* gap: 4px; */
  display: flex;
  align-self: start;
  flex-direction: column;
`;

export const ContainerInfoDescription = styled.div`
  width: 100%;
  height: auto;
  
  gap: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  align-self: start;
`;

export const ContainerItemNotFound = styled.div`
  width: 100%;
  height: auto;
  padding: 5rem 0;

  gap: 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  >img{
    width: 100%;
    height: auto;
    max-width: 150px;
  }

  >h6 {
    text-align: center;
  }
`;

export const Loading = styled.div`
  @-webkit-keyframes rotating {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
    
  @keyframes rotating {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  width: 88px;
  height: 88px;
  position: relative;
  margin: auto;

  background-color: transparent;
  border-top: 1px solid ${theme.colors.green.Verde_AgroReceita};
  border-bottom: 1px solid ${theme.colors.green.Verde_AgroReceita};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  animation: rotating 0.7s linear infinite;
`;